<div class="col text-center">
    <div class="row justify-content-center">
        <div class="dialog-title-box">
            <div class="col">
                <div class="row">
                    <div class="col pt-3">
                        <i [ngClass]="data.icon" class=" icon" id="questionIcon"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col pb-3 pt-3">
                        <span id="confirmation" class="title pb-1 mt-3 mb-3">
                            {{data.title}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<mat-dialog-content class="mat-typography mat-dialog-content">
<div class="col p-0">
    <h2 class="col maincontent pt-4 mb-1 text-center" id="confirmation">
        {{data.message}}
    </h2>
   
    <h2 class="col subcontent mb-2 text-center" id=""></h2>
</div>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
<div class="col text-center pb-3">
    <div class="row">
        <div class="col-lg-12 col-sm-12 pt-3 justify-content-center text-left">
            <button   mat-raised-button  mat-dialog-close="yes" tabindex="1 " type="button" id="yes"
                class="btn btn-primary  center-block w-70 my-2 me-2">
                Yes
            </button>
            <button   mat-raised-button  mat-dialog-close="no" tabindex="-1" type="button" id="no"
                class="btn btn-default center-block w-70 ml-3">
                No 
            </button>
        </div>
    </div>
</div>
</mat-dialog-actions>
